import { render } from "./ModelApp.vue?vue&type=template&id=0239ae67&scoped=true"
import script from "./ModelApp.vue?vue&type=script&lang=js"
export * from "./ModelApp.vue?vue&type=script&lang=js"

import "./ModelApp.vue?vue&type=style&index=0&id=0239ae67&lang=scss&scoped=true"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0239ae67"]])

export default __exports__